<template>
  <div class="fill-height">
    <v-card class="fill-height">
      <v-card-title class="p-1">
        <v-chip
            label small
            class="ma-2"
            color="secondary">
          گزارش گردش حساب واحدها
        </v-chip>
        <v-spacer/>
        <v-btn light icon @click="$router.push('/home')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-spacer/>
        <v-row>
          <v-col cols="12" md="9">
            <v-row>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col
                      cols="12"
                      md="5">
                    <v-autocomplete
                        :items="buildingList"
                        v-model="params.buildingId"
                        :error-messages="getError('buildingId')"
                        @change="onChangeBuilding"
                        auto-select-first
                        dense
                        outlined
                        append-icon="fas fa-angle-down"
                        label="انتخاب مجتمع"

                    />

                  </v-col>
                  <v-col
                      cols="12"
                      md="7">
                    <v-autocomplete
                        :items="unitItems"
                        v-model="params.unitId"
                        outlined
                        :error-messages="getError('unitId')"
                        dense
                        @change="onChangeUnit"
                        label=" انتخاب واحد"

                    />


                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" md="6">
                <v-row>
                  <v-col
                      cols="12"
                      md="6">
                    <date-picker placeholder=" تاریخ " v-model="params.toDate" color="#3b5694" clearable
                                 auto-submit>
                    </date-picker>
                    <span style="color: red" v-if="getError('toDate')" v-text="getError('toDate')"/>
                  </v-col>
                  <v-col cols="12" md="6" class="p-0 m-0 d-inline-flex">
                    <v-checkbox
                        v-for="acc in accountTypeItem" :key="acc.value"
                        v-model="acc.check"
                        :label="acc.text"
                        class="mr-1"
                    ></v-checkbox>
                    <span style="color: red" v-if="getError('accounts')" v-text="getError('accounts')"/>

                  </v-col>
                </v-row>

              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <v-row>
              <v-col
                  cols="12"
                  md="5" class="d-inline-flex mx-3">

                <v-btn small fab color="primary" @click="search">
                  <v-icon>mdi-cloud-search</v-icon>
                </v-btn>
                <v-btn v-if="dataItems && dataItems.length>0" class="mr-1" small fab color="error" @click="createPdf">
                  <v-icon>mdi-file-pdf</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>


        <v-spacer/>
      </v-card-text>
      <v-card-text>
        <b-table
            v-if="isMobile"
            responsive
            striped
            hover
            stacked="md"
            :items="dataItems"
            :fields="columns"
            show-empty
        >
<!--          documents-->
          <template #cell(documents)="row">
            <div v-if="row.item.documents" style="display: flex; gap: 12px; flex-wrap: wrap;">
                <span v-for="(doc,i) in row.item.documents" :key="i">
                     <v-chip small color="success" outlined>
                        <v-icon @click="download(doc)">mdi-arrow-down-bold</v-icon>
                          سند {{ i + 1 }}
                        </v-chip>
                </span>
            </div>
          </template>

<!--          bottom-row-->
          <template v-slot:bottom-row>
            <td style="border: none!important;"></td>

            <td style="border: none!important;">
              <strong>مجموع بدهکار:
                <strong v-if="formattedTotalDebtor && formattedTotalDebtor.includes('-')"
                        style="color: red">{{ formattedTotalDebtor }} </strong>
                <strong
                    v-if="formattedTotalDebtor && !formattedTotalDebtor.includes('-')">{{
                    formattedTotalDebtor
                  }} </strong>

              </strong>

            </td>
            <td style="border: none!important;">مجموع بستانکار:
              <strong>
                <strong v-if="formattedTotalCreditor && formattedTotalCreditor.includes('-')"
                        style="color: red">{{ formattedTotalCreditor }} </strong>
                <strong
                    v-if="formattedTotalCreditor && !formattedTotalCreditor.includes('-')">{{
                    formattedTotalCreditor
                  }} </strong>

              </strong>

            </td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>

          </template>
        </b-table>
        <b-table
            v-else
            sticky-header="450px"
            id="style-1"
            :items="dataItems"
            :fields="columns"
            show-empty
            striped>
          <!--          documents-->
          <template #cell(documents)="row">
            <div v-if="row.item.documents" style="display: flex; gap: 12px; flex-wrap: wrap;">
                <span v-for="(doc,i) in row.item.documents" :key="i">
                     <v-chip small color="success" outlined @click="download(doc)">
                        <v-icon  class="mx-1">mdi-arrow-down-bold</v-icon>
                          سند {{ i + 1 }}
                        </v-chip>
                </span>
            </div>
          </template>

<!--          bottom-row-->
          <template v-slot:bottom-row>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"><strong>مجموع</strong></td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>

            <td style="border: none!important;">
              <strong>
                <strong v-if="formattedTotalDebtor && formattedTotalDebtor.includes('-')"
                        style="color: red">{{ formattedTotalDebtor }} </strong>
                <strong
                    v-if="formattedTotalDebtor && !formattedTotalDebtor.includes('-')">{{
                    formattedTotalDebtor
                  }} </strong>

              </strong>

            </td>
            <td style="border: none!important;">
              <strong>
                <strong v-if="formattedTotalCreditor && formattedTotalCreditor.includes('-')"
                        style="color: red">{{ formattedTotalCreditor }} </strong>
                <strong
                    v-if="formattedTotalCreditor && !formattedTotalCreditor.includes('-')">{{
                    formattedTotalCreditor
                  }} </strong>

              </strong>

            </td>
            <td style="border: none!important;"></td>
            <td style="border: none!important;"></td>

          </template>
        </b-table>

      </v-card-text>
      <VueHtml2pdf
          :show-layout="false"
          :float-layout="true"
          :enable-download="true"
          :paginate-elements-by-height="700"
          filename="filename"
          :pdf-quality="2"
          :manual-pagination="true"
          pdf-format="a4"
          :html-to-pdf-options="htmlToPdfOptions"
          ref="html2Pdf">

        <section slot="pdf-content">

          <div class="container-fluid" style="direction: rtl">
            <!--          header-->
            <header class="report-header">
              <div class="header-left">
              </div>
              <div class="header-center">
                <div class="report-title">
                  گزارش گردش حساب واحد {{ unitName }} مجتمع {{ buildingName }}
                </div>
              </div>
              <div class="header-right">
                <div class="account-types">
        <span v-for="acc in accountTypeItem" :key="acc.value" class="account-type-item">
          <input
              type="checkbox"
              :id="acc.value"
              :name="acc.value"
              :value="acc.check"
              v-model="acc.check"
          >
          <label :for="acc.value">{{ acc.text }}</label>
        </span>
                </div>
                <div class="report-date">
                  <div class="report-date">
                    <span class="text-muted mr-1"> تاریخ :</span> {{ toDate }}
                  </div>
                </div>
              </div>
            </header>

            <!--          header-->
            <!--          body-->
            <form v-for="(items,j) in pdfItems" :key="j">
              <section class="pdf-item">
                <div class="container-fluid">
                  <div class="row p-2" style="margin-top: 20px">
                    <div class="col-12">
                      <table id="myTable">
                        <thead>
                        <tr class="header">
                          <th class="text-right">ردیف</th>
                          <th class="text-right">تاریخ</th>
                          <th class="text-right">سریال</th>
                          <th class="text-right">آرتیکل</th>
                          <th class="text-right">بدهکار</th>
                          <th class="text-right">بستانکار</th>
                          <th class="text-right"> مانده بدهکار</th>
                          <th class="text-right"> مانده بستانکار</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item ,i) in items" :key="i">
                          <td class="text-right">{{ (i + 1) + (25 * j) }}</td>
                          <td class="text-right">{{ item.date }}</td>
                          <td class="text-right">{{ item.serial }}</td>
                          <td class="text-right">{{ item.article }}</td>
                          <td class="text-right">{{ formatToPersian(item.debtor) }}</td>
                          <td class="text-right">{{ formatToPersian(item.creditor) }}</td>
                          <td class="text-right">{{ formatToPersian(item.remainingDebtor) }}</td>
                          <td class="text-right">{{ formatToPersian(item.remainingCreditor) }}</td>
                        </tr>
                        <tr v-if="j === pdfItems.length - 1">
                          <td style="border: none!important;"><strong>مجموع</strong></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;">
                            <strong>
                              <strong v-if="formattedTotalDebtor && formattedTotalDebtor.includes('-')"
                                      style="color: red">{{ formattedTotalDebtor }} </strong>
                              <strong
                                  v-if="formattedTotalDebtor && !formattedTotalDebtor.includes('-')">{{
                                  formattedTotalDebtor
                                }} </strong>

                            </strong>
                          </td>
                          <td style="border: none!important;">
                            <strong>
                              <strong v-if="formattedTotalCreditor && formattedTotalCreditor.includes('-')"
                                      style="color: red">{{ formattedTotalCreditor }} </strong>
                              <strong
                                  v-if="formattedTotalCreditor && !formattedTotalCreditor.includes('-')">{{
                                  formattedTotalCreditor
                                }} </strong>

                            </strong>
                          </td>
                          <td style="border: none!important;"></td>
                          <td style="border: none!important;"></td>

                        </tr>
                        </tbody>
                      </table>
                    </div>


                  </div>
                </div>
              </section>
              <div class="html2pdf__page-break"/>

            </form>
            <!--          body-->
          </div>

        </section>
      </VueHtml2pdf>
    </v-card>

  </div>
</template>

<script>
import Service from "./Service";
import {mapMutations} from "vuex";
import VueHtml2pdf from 'vue-html2pdf'
// import persianDate from 'persian-date'

export default {

  name: 'ReportDebt',
  components: {
    VueHtml2pdf
  },
  data() {
    return {
      isMobile: window.innerWidth < 768,
      buildingList: [],
      unitItems: [],
      accountTypeItem: [],
      params: {},
      selectAll: false,
      dataItems: [],
      pdfItems: [],
      bindingErrors: [],
      fromDate: '',
      toDate: '',
      buildingName: '',
      unitName: '',
      columns: [
        {key: 'index', label: 'ردیف', formatter: (value, key, item) => this.dataItems.indexOf(item) + 1},
        {key: 'date', label: 'تاریخ',},
        {key: 'serial', label: 'سریال',},
        {key: 'article', label: 'آرتیکل',},
        {
          key: 'debtor',
          label: 'بدهکار',
          formatter: (value) => this.formatToPersian(value),
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'creditor',
          label: 'بستانکار',
          formatter: (value) => this.formatToPersian(value),
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'remainingDebtor',
          label: 'مانده بدهکار',
          formatter: (value) => this.formatToPersian(value),
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'remainingCreditor',
          label: 'مانده بستانکار',
          formatter: (value) => this.formatToPersian(value),
          sortable: true,
          sortDirection: 'desc'
        },
        {key: 'documents', label: 'سندها'},

      ],

      htmlToPdfOptions: {
        margin: [10, 1, 10, 2],
      }

    };

  },
  mounted() {
    window.addEventListener("resize", this.checkScreen);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth < 768;
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),
    handleInput(value) {
      this.$emit('input', value)
    },

    download(file) {
      Service.download(file.uuid).then(response => {
            if (response && response.status === 200) {
              let blob = new Blob([response.data], {type: file.type})
              let url = window.URL.createObjectURL(blob)
              const link = document.createElement('a')
              link.href = url
              link.download = file.caption // 重命名文件
              link.click()

            } else if (response && response.response.status === 400) {
              this.bindingErrors = response.response.data;
              console.log(this.bindingErrors)
            }})
    },

    onChangeBuilding() {
      this.buildingName = this.buildingList.filter(b => b.value === this.params.buildingId)[0].text
      Service.getBuildingItems(this.params.buildingId).then(response => {
        this.unitItems = response.data.unitItems
        this.accountTypeItem = response.data.accountTypeItem
        this.params = response.data.params
      })
    },
    onChangeUnit() {
      this.unitName = this.unitItems.filter(b => b.value === this.params.unitId)[0].text
    },

    fillDataItems() {
      Service.getPage().then(response => {
        this.buildingList = response.data.buildingList
        this.params = response.data.params

      });
    },
    createPdf() {
      this.$refs.html2Pdf.generatePdf()
    },
    search() {
      this.dataItems = []
      this.bindingErrors = []
      this.params.accounts = this.accountTypeItem
          .filter(acc => acc.check)
          .map(acc => acc.value);
      this.$progress({message: 'درحال جستجو...'}, true)
      Service.search(this.params).then(response => {
        if (response && response.status === 200) {
          this.$root.$emit('Progress')
          this.dataItems = response.data.outList
          this.pdfItems = response.data.pdfList
          this.toDate = this.params.toDate
        } else if (response && response.response.status === 400) {
          this.$root.$emit('Progress')
          this.bindingErrors = response.response.data;
        }
      })
    },
    formatToPersian(value) {
      if (typeof value !== 'number' && typeof value !== 'string') return value;
      try {
        // از Intl.NumberFormat برای تبدیل استاندارد استفاده می‌کنیم
        return new Intl.NumberFormat("fa-IR", {
          maximumFractionDigits: 20 // برای نمایش کامل اعداد اعشاری
        }).format(Number(value));
      } catch (e) {
        console.error("Error formatting number:", e);
        return value.toLocaleString(); // در صورت خطا، مقدار اصلی را برگردان
      }
    }

  },

  computed: {
    rawTotalDebtor() {
      return this.dataItems.reduce((sum, item) => {
        const debtor = Number(item.debtor);
        return sum + (isNaN(debtor) ? 0 : debtor);
      }, 0);
    },
    // فرمت کردن مجموع
    formattedTotalDebtor() {
      return this.formatToPersian(this.rawTotalDebtor); //
    },
    rawTotalCreditor() {
      return this.dataItems.reduce((sum, item) => {
        const creditor = Number(item.creditor);
        return sum + (isNaN(creditor) ? 0 : creditor);
      }, 0);
    },
    // فرمت کردن مجموع
    formattedTotalCreditor() {
      return this.formatToPersian(this.rawTotalCreditor); //
    },
  },
  created() {
    this.fillDataItems()
    this.setDrawer(false)
  }

}
</script>
<style src="@/assets/styles/pdfReportStyles.css"></style>
<style>
.table th, .table td {
  padding: 5px !important;
}
</style>
